import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detail", "detailTitle", "detailContent", "detailActions"]

  showDetail(event) {
    const bay = event.params.bay
    const coachId = event.params.coach
    const coachName = event.params.coachName
    const owner = event.params.owner
    const date = event.params.date

    this.detailTitleTarget.textContent = `Bay ${bay}`
    this.detailContentTarget.innerHTML = `
      <div class="rounded-xl border border-white/5 bg-white/5 p-4">
        <div class="text-sm text-zinc-400 mb-1">Coach</div>
        <div class="text-white font-semibold">${coachName}</div>
      </div>
      <div class="rounded-xl border border-white/5 bg-white/5 p-4">
        <div class="text-sm text-zinc-400 mb-1">Owner</div>
        <div class="text-white font-semibold">${owner || 'Unknown'}</div>
      </div>
      <div class="rounded-xl border border-white/5 bg-white/5 p-4">
        <div class="text-sm text-zinc-400 mb-1">Date</div>
        <div class="text-white font-semibold">${date}</div>
      </div>
    `
    this.detailActionsTarget.innerHTML = `
      <a href="/facility/work_orders/new?coach_id=${coachId}" class="block w-full text-center px-4 py-2.5 rounded-lg bg-amber-500 hover:bg-amber-600 text-black font-semibold text-sm transition-colors">
        Create Work Order
      </a>
      <a href="/facility/coach_updates/new?coach_id=${coachId}" class="block w-full text-center px-4 py-2.5 rounded-lg bg-white/5 hover:bg-white/10 text-white font-medium text-sm border border-white/10 transition-colors">
        Send Update to Owner
      </a>
    `

    this.detailTarget.classList.remove("hidden")
  }

  hideDetail() {
    this.detailTarget.classList.add("hidden")
  }
}
